import { Fragment } from "react"

import { Spinner, buttonVariants } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import { PaymentErrorMessage } from "../payment-error/payment-error-message"

import { useAdyen } from "./use-adyen.hook"

export const Adyen = ({ type, order }) => {
  const { t } = useTranslation(null, {
    keyPrefix: "Payment.Methods",
  })

  const { mountRef, isConfirmChargeLoading, error } = useAdyen({
    paymentMethodType: type,
    order,
  })

  return (
    <div
      /* https://docs.adyen.com/online-payments/web-drop-in/customization */
      data-testid="web-portal-payment-method-adyen"
      sx={{
        ".adyen-checkout__button--pay": buttonVariants["solid"],
        ".adyen-checkout__input": {
          borderRadius: 0,

          "&--focus, &:active, &:focus": {
            "&, &:hover": {
              border: ({ colors }) => `1px solid ${colors.primary}`,
              boxShadow: ({ colors }) => `0 0 0 1px ${colors.primary}`,
            },
          },
        },
        ".adyen-checkout__label__text": {
          fontWeight: "bold",
        },
        ".adyen-checkout__label--focused .adyen-checkout__label__text": {
          color: "text",
        },
        ".adyen-checkout__checkbox__input:checked": {
          "&+.adyen-checkout__checkbox__label:after": {
            backgroundColor: "primary",
            borderColor: "primary",
          },
        },
        ".adyen-checkout__applepay__button": {
          width: "100%",
        },
      }}
    >
      <Fragment>
        <div ref={mountRef} />

        <PaymentErrorMessage paymentError={error} />

        {isConfirmChargeLoading && (
          <div sx={{ textAlign: "center" }}>
            <div>{t("3ds.description")}</div>
            <Spinner />
          </div>
        )}
      </Fragment>
    </div>
  )
}
